import type { ReactNode } from 'react';

import styles from './EmptyState.module.css';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  /** The way out, where the emptiness names its own remedy. A state that is
   *  merely reporting has nowhere to send anyone and takes none. */
  action?: { label: string; onClick: () => void };
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div className={styles.empty}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <p className={styles.title}>{title}</p>
      {description && <p className={styles.description}>{description}</p>}
      {action && (
        <div className={styles.actions}>
          <button type="button" className={styles.action} onClick={action.onClick}>
            {action.label}
          </button>
        </div>
      )}
    </div>
  );
}
